import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { images } from "../../config/images";
import {
  Box,
  Card,
  CardContent,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import { Tab } from "react-bootstrap";
import {
  generateGlovesTrackingReportPDF,
  getBatchGlovesTrackingDetails,
  getTunnelOvenDataWithLeaching,
} from "./services";
import dayjs from "dayjs";
import {
  getAcConditioningStationDetails,
  getAutoclaveStationDetails,
  getChlorinationStationDetails,
  getCuttingStationDetails,
  getExtraAcConditionerStationDetails,
  getHancoMachineStationDetails,
  getLeachingStationDetails,
  getProngOven1StationDetails,
  getProngOven2StationDetails,
  getProngOven3StationDetails,
  getProngOven4StationDetails,
  getStaticLeachingStationDetails,
  getStrippingStationDetails,
  getTumbleDrying1StationDetails,
  getTumbleDrying2StationDetails,
  getTunnelOvenStationDetails,
  getWashineMachine1StationDetails,
  getWashineMachine2StationDetails,
} from "../ProductionLine/services";
import { toast, ToastContainer } from "react-toastify";
import RobotParameter from "../ProductionLine/RobotParameter";
import ProductionLineVisualInspection from "../ProductionLine/ProductionLineVisualInspection";
import Button from "../../components/Button/Button";

const GlovesReport = () => {
  const [openPopup, setOpenPopup] = React.useState(false);
  const [washing2Popup, setWashing2Popup] = React.useState(false);
  const [leachingPopup, setLeachingPopup] = React.useState(false);
  const [tunnelOvenPopup, setTunnelOvenPopup] = useState(false);
  const [autoClavePopup, setAutoClavePopup] = useState(false);
  const [acConditioningPopup, setAcConditioningPopup] = useState(false);
  const [acConditioningData, setAcConditioningData] = useState([]);
  const [extraConditioningPopup, setExtraConditioningPopup] = useState(false);
  const [extraConditioningData, setExtraAcConditioningData] = useState([]);
  const [autoClaveData, setAutoClaveData] = useState([]);
  const [trackingBatchData, setTrackingBatchData] = useState({});
  const [washing1, setWashing1] = useState([]);
  const [washing2, setWashing2] = useState([]);
  const [leachingData, setLeachingData] = useState([]);
  const [tunnelOvenData, setTunnelOvenData] = useState([]);
  const [prong1Popup, setProng1Popup] = useState(false);
  const [prong2Popup, setProng2Popup] = useState(false);
  const [prong3Popup, setProng3Popup] = useState(false);
  const [prong4Popup, setProng4Popup] = useState(false);
  const [prongOven1Data, setProng1Data] = useState([]);
  const [prongOven2Data, setProng2Data] = useState([]);
  const [prongOven3Data, setProng3Data] = useState([]);
  const [prongOven4Data, setProng4Data] = useState([]);
  const [cuttingData, setCuttingData] = useState([]);
  const [cuttingPopup, setCuttingPopup] = useState(false);
  const [chlorinationData, setChlorinationData] = useState([]);
  const [chlorinationPopup, setchlorinationPopup] = useState(false);
  const [dippingpopup, setDippingPopup] = useState(false);
  const [strippingPopup, setStrippingPopup] = useState(false);
  const [strippingData, setStrippingData] = useState([]);
  const [isVisualInspection, setIsVisualInspection] = useState(false);
  const [staticLeachingData, setStatingLeachingData] = useState([]);
  const [staticLeachingPopup, setStatingLeachingPopup] = useState(false);
  const [tumbleDryingData, setTumbleDryingData] = useState([]);
  const [tumbleDryingPopup, setTumbleDryingPopup] = useState(false);
  const [tumbleDrying2Data, setTumbleDrying2Data] = useState([]);
  const [tumbleDrying2Popup, setTumbleDrying2Popup] = useState(false);
  const [hancoWashingPopup, setHancoWashingPopup] = useState(false);
  const [hancoWashingData, setHancoWashingData] = useState([]);
  const [isPopup, setisPopup] = useState(false);
  const [successPopup, setSuccessPopup] = useState(false);

  console.log("SDFSDFSDFDS", tunnelOvenData);

  const [temperatures, setTemperatures] = useState([]);
  useEffect(() => {
    if (tunnelOvenData.length > 0) {
      const tempValues = [
        tunnelOvenData[0].set_temp_zone1,
        tunnelOvenData[0].set_temp_zone2,
        tunnelOvenData[0].set_temp_zone3,
        tunnelOvenData[0].set_temp_zone4,
        tunnelOvenData[0].set_temp_zone5,
        tunnelOvenData[0].set_temp_zone6,
        tunnelOvenData[0].set_temp_zone7,
        tunnelOvenData[0].set_temp_zone8,
      ].map((temp) => parseFloat(temp)); // Convert to number
      setTemperatures(tempValues);
    }
  }, [tunnelOvenData]);

  console.log("trackingBatchData", trackingBatchData);
  const rows = [
    {
      inFeed: "03:40",
      outFeed: "04:50",
      hotLeaching: { temp: "34°C", start: "03:51", end: "05:50" },
      coldLeaching: { start: "05:51", end: "06:15" },
      tunnelOven: { start: "04:18", end: "09:13" },
      tunnelOvenActualTemp: {
        time: "07:00",
        zones: ["34°C", "42°C", "48°C", "52°C", "58°C", "62°C", "64°C", "68°C"],
      },
    },
  ];

  const params = useParams();

  useEffect(() => {
    handleGloveBatchData();
  }, [params.id]);

  const navigate = useNavigate();

  const handleGloveBatchData = async () => {
    try {
      const resp = await getBatchGlovesTrackingDetails(params.id);
      if (resp.status == 200 || resp.status == 201) {
        setTrackingBatchData(resp.data);
      }
    } catch (error) {
      setTrackingBatchData([]);
    }
  };
  const handleOpenPopup = (station) => {
    if (station == "Washing") {
      handleGetWashing1Data();
      setOpenPopup(true);
    }
    if (station == "Washing2") {
      handleGetgetWashineMachine2Data();
      setWashing2Popup(true);
    }
    if (station == "Leaching") {
      handleGetLeaching();
      setLeachingPopup(true);
    }
    if (station == "Tunnel Oven") {
      handleGetTunnelOven();
      setTunnelOvenPopup(true);
    }
    if (station == "Autoclave") {
      handleGetAutoClave();
      setAutoClavePopup(true);
    }
    if (station == "Prong Oven1") {
      handleGetProngOven();
      setProng1Popup(true);
    }
    if (station == "Prong Oven2") {
      handleGetProngOven2();
      setProng2Popup(true);
    }
    if (station == "Prong Oven3") {
      handleGetProngOven3();
      setProng3Popup(true);
    }
    if (station == "Prong Oven4") {
      handleGetProngOven4();
      setProng4Popup(true);
    }
    if (station == "AC Conditioning") {
      handleGetAcConditioningData();
      setAcConditioningPopup(true);
    }
    if (station == "Extra AC Conditioning") {
      handleGetExtraConditionerData();
      setExtraConditioningPopup(true);
    }
    if (station == "Cutting") {
      handleGetCuttingData();
      setCuttingPopup(true);
    }
    if (station == "Chlorination") {
      handleGetChlorinationData();
      setchlorinationPopup(true);
    }
    if (station == "Dipping") {
      setDippingPopup(true);
    }
    if (station == "Out Feed Visual Inspection") {
      navigate(`/feed-visual-inspection/${params.id}`);
    }
    if (station == "Stripping") {
      handleGetStrippingData();
      setStrippingPopup(true);
    }
    if (station == "Visual Inspection") {
      setIsVisualInspection(true);
    }
    if (station == "Static Leaching") {
      handleGetStaticLeachingData();
      setStatingLeachingPopup(true);
    }
    if (station == "Tumble Drying1") {
      handleGetTumbleDrying1();
      setTumbleDryingPopup(true);
    }
    if (station == "Tumble Drying2") {
      handleGetTumbleDrying2();
      setTumbleDrying2Popup(true);
    }
    if (station == "Hanco Washing") {
      handleGetHancoMachineData();
      setHancoWashingPopup(true);
    }
  };
  const handleGetChlorinationData = async () => {
    try {
      const resp = await getChlorinationStationDetails(params.id);
      if (resp.status == 200 || resp.status == 201) {
        setChlorinationData(resp.data.payload);
      }
    } catch (error) {
      setChlorinationData([]);
      console.log("handlesubmit", error);
    }
  };
  const handleGetWashing1Data = async () => {
    try {
      const resp = await getWashineMachine1StationDetails(params.id);
      if (resp.status == 200 || resp.status == 201) {
        setWashing1(resp.data.payload);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setWashing1([]);

      console.log("handlesubmit", error);
    }
  };
  const handleGetgetWashineMachine2Data = async () => {
    try {
      const resp = await getWashineMachine2StationDetails(params.id);
      if (resp.status == 200 || resp.status == 201) {
        setWashing2(resp.data.payload);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setWashing2([]);
      console.log("handlesubmit", error);
    }
  };
  const handleGetLeaching = async () => {
    try {
      const resp = await getLeachingStationDetails(params.id);
      if (resp.status == 200 || resp.status == 201) {
        setLeachingData(resp.data.payload);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setLeachingData([]);
      console.log("handlesubmit", error);
    }
  };

  const handleGetTunnelOven = async () => {
    try {
      const resp = await getTunnelOvenDataWithLeaching(params.id);
      if (resp.status == 200 || resp.status == 201) {
        setTunnelOvenData(resp.data.payload);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setLeachingData([]);
      console.log("handlesubmit", error);
    }
  };
  const handleGetProngOven = async () => {
    try {
      const resp = await getProngOven1StationDetails(params.id);
      if (resp.status == 200 || resp.status == 201) {
        setProng1Data(resp.data.payload);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setProng1Data([]);
      console.log("handlesubmit", error);
    }
  };
  const handleGetProngOven2 = async () => {
    try {
      const resp = await getProngOven2StationDetails(params.id);
      if (resp.status == 200 || resp.status == 201) {
        setProng2Data(resp.data.payload);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setProng2Data([]);
      console.log("handlesubmit", error);
    }
  };
  const handleGetProngOven3 = async () => {
    try {
      const resp = await getProngOven3StationDetails(params.id);
      if (resp.status == 200 || resp.status == 201) {
        setProng3Data(resp.data.payload);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setProng3Data([]);
      console.log("handlesubmit", error);
    }
  };
  const handleGetProngOven4 = async () => {
    try {
      const resp = await getProngOven4StationDetails(params.id);
      if (resp.status == 200 || resp.status == 201) {
        setProng4Data(resp.data.payload);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setProng4Data([]);
      console.log("handlesubmit", error);
    }
  };
  const handleGetAutoClave = async () => {
    try {
      const resp = await getAutoclaveStationDetails(params.id);
      if (resp.status == 200 || resp.status == 201) {
        setAutoClaveData(resp.data.payload);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setAutoClaveData([]);
      console.log("handlesubmit", error);
    }
  };
  const handleGetAcConditioningData = async () => {
    try {
      const resp = await getAcConditioningStationDetails(params.id);
      if (resp.status == 200 || resp.status == 201) {
        setAcConditioningData(resp.data.payload);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setAcConditioningData([]);
      console.log("handlesubmit", error);
    }
  };
  const handleGetExtraConditionerData = async () => {
    try {
      const resp = await getExtraAcConditionerStationDetails(params.id);
      if (resp.status == 200 || resp.status == 201) {
        setExtraAcConditioningData(resp.data.payload);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setExtraAcConditioningData([]);
      console.log("handlesubmit", error);
    }
  };
  const handleGetCuttingData = async () => {
    try {
      const resp = await getCuttingStationDetails(params.id);
      if (resp.status == 200 || resp.status == 201) {
        setCuttingData(resp.data.payload);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setCuttingData([]);
      console.log("handlesubmit", error);
    }
  };
  const handleGetStrippingData = async () => {
    try {
      const resp = await getStrippingStationDetails(params.id);
      if (resp.status == 200 || resp.status == 201) {
        setStrippingData(resp.data.payload);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setStrippingData([]);
      console.log("handlesubmit", error);
    }
  };
  const handleGetStaticLeachingData = async () => {
    try {
      const resp = await getStaticLeachingStationDetails(params.id);
      if (resp.status == 200 || resp.status == 201) {
        setStatingLeachingData(resp.data.payload);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setStatingLeachingData([]);
      console.log("handlesubmit", error);
    }
  };
  const handleGetTumbleDrying1 = async () => {
    try {
      const resp = await getTumbleDrying1StationDetails(params.id);
      if (resp.status == 200 || resp.status == 201) {
        setTumbleDryingData(resp.data.payload);
      }
    } catch (error) {
      setTumbleDryingData([]);
      console.log("handlesubmit", error);
    }
  };
  const handleGetTumbleDrying2 = async () => {
    try {
      const resp = await getTumbleDrying2StationDetails(params.id);
      if (resp.status == 200 || resp.status == 201) {
        setTumbleDrying2Data(resp.data.payload);
      }
    } catch (error) {
      setTumbleDrying2Data([]);
      console.log("handlesubmit", error);
    }
  };
  const handleGetHancoMachineData = async () => {
    try {
      const resp = await getHancoMachineStationDetails(params.id);
      if (resp.status == 200 || resp.status == 201) {
        setHancoWashingData(resp.data.payload);
      }
    } catch (error) {
      setHancoWashingData([]);
      console.log("handlesubmit", error);
    }
  };

  const handleExcelClick = async () => {
    setisPopup(false);
    setSuccessPopup(true);
    const param = {
      batch_id: params.id,
    };
    try {
      const resp = await generateGlovesTrackingReportPDF(param);
      if (resp.status == 200 || resp.status == 201) {
        setTimeout(() => {
          setSuccessPopup(false);
        }, 5000);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  return (
    <>
      {isVisualInspection ? (
        <ProductionLineVisualInspection closeModal={setIsVisualInspection} />
      ) : (
        <div className="page-wraper">
          <ToastContainer />
          <div className="page-header">
            <Link to="/gloves-tracking" className="page-back-btn">
              <ArrowBackIcon />
              <span>Gloves Tracking</span>
            </Link>

            <div
              className="header-btn-group"
              onClick={() => setisPopup(true)}
              style={{ cursor: "pointer" }}
            >
              <img src={images.PDFDownload} alt="pdf" />
            </div>
          </div>
          <div className="table-responsive">
            <Table className="dipping-params">
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{ background: "#EFF5FF", fontWeight: "bold" }}
                  >
                    Operation
                  </TableCell>
                  <TableCell
                    style={{ background: "#EFF5FF", fontWeight: "bold" }}
                  >
                    Date
                  </TableCell>
                  <TableCell
                    style={{ background: "#EFF5FF", fontWeight: "bold" }}
                  >
                    Shift
                  </TableCell>
                  <TableCell
                    style={{ background: "#EFF5FF", fontWeight: "bold" }}
                  >
                    Start Date Time
                  </TableCell>
                  <TableCell
                    style={{ background: "#EFF5FF", fontWeight: "bold" }}
                  >
                    End Date Time
                  </TableCell>
                  <TableCell
                    style={{ background: "#EFF5FF", fontWeight: "bold" }}
                  >
                    Good
                  </TableCell>
                  <TableCell
                    style={{ background: "#EFF5FF", fontWeight: "bold" }}
                  >
                    Reject
                  </TableCell>
                  <TableCell
                    style={{ background: "#EFF5FF", fontWeight: "bold" }}
                  >
                    Hold
                  </TableCell>
                  <TableCell
                    style={{ background: "#EFF5FF", fontWeight: "bold" }}
                  >
                    Operator Name
                  </TableCell>
                  <TableCell
                    style={{ background: "#EFF5FF", fontWeight: "bold" }}
                  >
                    Remarks
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="gloves-report-body">
                {trackingBatchData?.stations &&
                  Object.keys(trackingBatchData.stations).map((station) => {
                    const data = trackingBatchData.stations[station];

                    // Check if the data is an array
                    if (Array.isArray(data)) {
                      if (data.length === 0) {
                        // Render a row with "--" in all cells for the station
                        return (
                          <TableRow key={station}>
                            <TableCell>
                              <div
                                className="icon-text-container"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    handleOpenPopup(station.replace(/_/g, " "))
                                  }
                                >
                                  <VisibilityIcon />
                                </IconButton>
                                <span style={{ marginLeft: "8px" }}>
                                  <b>{station.replace(/_/g, " ")}</b>
                                </span>
                              </div>
                            </TableCell>
                            <TableCell>-</TableCell>
                            <TableCell>-</TableCell>
                            <TableCell>-</TableCell>
                            <TableCell>-</TableCell>
                            <TableCell>-</TableCell>
                            <TableCell>-</TableCell>
                            <TableCell>-</TableCell>
                            <TableCell>-</TableCell>
                            <TableCell>-</TableCell>
                          </TableRow>
                        );
                      }
                      return data.map((item, index) => (
                        <TableRow key={`${station}-${index}`}>
                          <TableCell>
                            <div
                              className="icon-text-container"
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <IconButton
                                size="small"
                                onClick={() =>
                                  handleOpenPopup(station.replace(/_/g, " "))
                                }
                              >
                                <VisibilityIcon />
                              </IconButton>
                              <span style={{ marginLeft: "8px" }}>
                                <b>{station.replace(/_/g, " ")}</b>
                              </span>
                            </div>
                          </TableCell>
                          <TableCell>
                            {item.created_at && dayjs(item.created_at).isValid()
                              ? dayjs(item.created_at).format("YYYY-MM-DD")
                              : "--"}
                          </TableCell>
                          <TableCell>{item.shift_name || "--"}</TableCell>
                          <TableCell>
                            {item.start_time && dayjs(item.start_time).isValid()
                              ? dayjs(item.start_time).format("HH:mm:ss")
                              : "--"}
                          </TableCell>
                          <TableCell>
                            {item.stop_time && dayjs(item.stop_time).isValid()
                              ? dayjs(item.stop_time).format("HH:mm:ss")
                              : "--"}
                          </TableCell>
                          <TableCell>
                            <Box
                              className={
                                item.good !== null && item.good !== undefined
                                  ? "good-status"
                                  : ""
                              }
                            >
                              {item.good !== null && item.good !== undefined
                                ? item.good
                                : "--"}
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box
                              className={
                                item.reject !== null &&
                                item.reject !== undefined
                                  ? "reject-status"
                                  : ""
                              }
                            >
                              {item.reject !== null && item.reject !== undefined
                                ? item.reject
                                : "--"}
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box
                              className={
                                item.hold !== null && item.hold !== undefined
                                  ? "hold-status"
                                  : ""
                              }
                            >
                              {item.hold !== null && item.hold !== undefined
                                ? item.hold
                                : "--"}
                            </Box>
                          </TableCell>
                          <TableCell>{item.operator}</TableCell>
                          <TableCell>{item.remarks}</TableCell>
                        </TableRow>
                      ));
                    } else {
                      // Handle the case where data is an object
                      return (
                        <TableRow key={station}>
                          <TableCell>
                            <div
                              className="icon-text-container"
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <IconButton
                                size="small"
                                onClick={() =>
                                  handleOpenPopup(station.replace(/_/g, " "))
                                }
                              >
                                <VisibilityIcon />
                              </IconButton>
                              <span style={{ marginLeft: "8px" }}>
                                <b>{station.replace(/_/g, " ")}</b>
                              </span>
                            </div>
                          </TableCell>
                          <TableCell>
                            {data.created_at && dayjs(data.created_at).isValid()
                              ? dayjs(data.created_at).format("YYYY-MM-DD")
                              : "--"}
                          </TableCell>
                          <TableCell>{data.shift_name || "--"}</TableCell>
                          <TableCell>
                            {data.start_time && dayjs(data.start_time).isValid()
                              ? dayjs(data.start_time).format("HH:mm:ss")
                              : "--"}
                          </TableCell>
                          <TableCell>
                            {data.stop_time && dayjs(data.stop_time).isValid()
                              ? dayjs(data.stop_time).format("HH:mm:ss")
                              : "--"}
                          </TableCell>
                          <TableCell>
                            <Box
                              className={
                                data.good !== null && data.good !== undefined
                                  ? "good-status"
                                  : ""
                              }
                            >
                              {data.good !== null && data.good !== undefined
                                ? data.good
                                : "--"}
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box
                              className={
                                data.reject !== null &&
                                data.reject !== undefined
                                  ? "reject-status"
                                  : ""
                              }
                            >
                              {data.reject !== null && data.reject !== undefined
                                ? data.reject
                                : "--"}
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box
                              className={
                                data.hold !== null && data.hold !== undefined
                                  ? "hold-status"
                                  : ""
                              }
                            >
                              {data.hold !== null && data.hold !== undefined
                                ? data.hold
                                : "--"}
                            </Box>
                          </TableCell>
                          <TableCell>{data.operator}</TableCell>
                          <TableCell>{data.remarks}</TableCell>
                        </TableRow>
                      );
                    }
                  })}
              </TableBody>
            </Table>
          </div>
          {openPopup && (
            <>
              <div
                className="modal-container"
                style={{ height: "40vh", top: "35vh" }}
              >
                <div className="modal-header">
                  <div className="modal-title">
                    WASHING MACHINE PROCESS SHEET
                  </div>
                  <div
                    onClick={() => setOpenPopup(false)}
                    style={{ cursor: "pointer" }}
                  >
                    <CloseIcon />
                  </div>
                </div>
                <div className="modal-table-wrapper">
                  <Table className="dipping-params">
                    <TableHead>
                      <TableRow>
                        <TableCell>Max Temp (°C)</TableCell>
                        <TableCell>Min Temp (°C)</TableCell>
                        <TableCell>Time (Minutes)</TableCell>
                        <TableCell>Water Level (Liters)</TableCell>
                        <TableCell>Cycle Start Time</TableCell>
                        <TableCell>Cycle End Time</TableCell>
                        <TableCell>Operator</TableCell>
                        <TableCell>Supervisor</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className="gloves-report-body">
                      {washing1?.map((e) => {
                        return (
                          <TableRow>
                            <TableCell>
                              {e.max_temp ? e.max_temp : ""}
                            </TableCell>
                            <TableCell>
                              {e.min_temp ? e.min_temp : ""}
                            </TableCell>
                            <TableCell>
                              {e.time_minutes ? e.time_minutes : ""}
                            </TableCell>
                            <TableCell>
                              {e.water_level ? e.water_level : ""}
                            </TableCell>
                            <TableCell>
                              {e
                                ? e?.cycle_start_time
                                  ? dayjs(e.cycle_start_time).format("HH:mm:ss")
                                  : "--"
                                : "--"}
                            </TableCell>
                            <TableCell>
                              {e
                                ? e?.cycle_end_time
                                  ? dayjs(e.cycle_end_time).format("HH:mm:ss")
                                  : "--"
                                : "--"}
                            </TableCell>
                            <TableCell>
                              {e.operator ? e.operator : "--"}
                            </TableCell>
                            <TableCell>
                              {e.supervisor ? e.supervisor : "--"}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </div>
              </div>
              <div
                className="modal-overlay"
                onClick={() => setOpenPopup(false)}
              ></div>
            </>
          )}

          {washing2Popup && (
            <>
              <div
                className="modal-container"
                style={{ height: "40vh", top: "35vh" }}
              >
                <div className="modal-header">
                  <div className="modal-title">
                    WASHING MACHINE 2 PROCESS SHEET
                  </div>
                  <div
                    onClick={() => setWashing2Popup(false)}
                    style={{ cursor: "pointer" }}
                  >
                    <CloseIcon />
                  </div>
                </div>
                <div className="modal-table-wrapper">
                  <Table className="dipping-params">
                    <TableHead>
                      <TableRow>
                        <TableCell>Max Temp (°C)</TableCell>
                        <TableCell>Min Temp (°C)</TableCell>
                        <TableCell>Time (Minutes)</TableCell>
                        <TableCell>Water Level (Liters)</TableCell>
                        <TableCell>Cycle Start Time</TableCell>
                        <TableCell>Cycle End Time</TableCell>
                        <TableCell>Operator</TableCell>
                        <TableCell>Supervisor</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className="gloves-report-body">
                      {washing2?.map((e) => {
                        return (
                          <TableRow>
                            <TableCell>
                              {e.max_temp ? e.max_temp : ""}
                            </TableCell>
                            <TableCell>
                              {e.min_temp ? e.min_temp : ""}
                            </TableCell>
                            <TableCell>
                              {e.time_minutes ? e.time_minutes : ""}
                            </TableCell>
                            <TableCell>
                              {e.water_level ? e.water_level : ""}
                            </TableCell>
                            <TableCell>
                              {e
                                ? e?.cycle_start_time
                                  ? dayjs(e.cycle_start_time).format("HH:mm:ss")
                                  : "--"
                                : "--"}
                            </TableCell>
                            <TableCell>
                              {e
                                ? e?.cycle_end_time
                                  ? dayjs(e.cycle_end_time).format("HH:mm:ss")
                                  : "--"
                                : "--"}
                            </TableCell>
                            <TableCell>
                              {e.operator ? e.operator : "--"}
                            </TableCell>
                            <TableCell>
                              {e.supervisor ? e.supervisor : "--"}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </div>
              </div>
              <div
                className="modal-overlay"
                onClick={() => setWashing2Popup(false)}
              ></div>
            </>
          )}
          {hancoWashingPopup && (
            <>
              <div
                className="modal-container"
                style={{ height: "40vh", top: "35vh" }}
              >
                <div className="modal-header">
                  <div className="modal-title">HANCO WASHING PROCESS SHEET</div>
                  <div
                    onClick={() => setHancoWashingPopup(false)}
                    style={{ cursor: "pointer" }}
                  >
                    <CloseIcon />
                  </div>
                </div>
                <div className="modal-table-wrapper">
                  <Table className="dipping-params">
                    <TableHead>
                      <TableRow>
                        <TableCell>Max Temp (°C)</TableCell>
                        <TableCell>Min Temp (°C)</TableCell>
                        <TableCell>Time (Minutes)</TableCell>
                        <TableCell>Water Level (Liters)</TableCell>
                        <TableCell>Cycle Start Time</TableCell>
                        <TableCell>Cycle End Time</TableCell>
                        <TableCell>Operator</TableCell>
                        <TableCell>Supervisor</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className="gloves-report-body">
                      {hancoWashingData?.map((e) => {
                        return (
                          <TableRow>
                            <TableCell>
                              {e.max_temp ? e.max_temp : ""}
                            </TableCell>
                            <TableCell>
                              {e.min_temp ? e.min_temp : ""}
                            </TableCell>
                            <TableCell>
                              {e.time_minutes ? e.time_minutes : ""}
                            </TableCell>
                            <TableCell>
                              {e.water_level ? e.water_level : ""}
                            </TableCell>
                            <TableCell>
                              {e
                                ? e?.cycle_start_time
                                  ? dayjs(e.cycle_start_time).format("HH:mm:ss")
                                  : "--"
                                : "--"}
                            </TableCell>
                            <TableCell>
                              {e
                                ? e?.cycle_end_time
                                  ? dayjs(e.cycle_end_time).format("HH:mm:ss")
                                  : "--"
                                : "--"}
                            </TableCell>
                            <TableCell>
                              {e.operator ? e.operator : "--"}
                            </TableCell>
                            <TableCell>
                              {e.supervisor ? e.supervisor : "--"}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </div>
              </div>
              <div
                className="modal-overlay"
                onClick={() => setHancoWashingPopup(false)}
              ></div>
            </>
          )}

          {leachingPopup && (
            <>
              <div
                className="modal-container"
                style={{ height: "40vh", top: "35vh" }}
              >
                <div className="modal-header">
                  <div className="modal-title">Leaching PROCESS SHEET</div>
                  <div
                    onClick={() => setLeachingPopup(false)}
                    style={{ cursor: "pointer" }}
                  >
                    <CloseIcon />
                  </div>
                </div>
                <div className="modal-table-wrapper">
                  <div
                    style={{
                      width: "100%",
                      overflow: "auto",
                      maxHeight: "400px",
                    }}
                    className="gloves-report-data"
                  >
                    <Table className="gloves-params">
                      <TableHead>
                        <TableRow>
                          <TableCell colSpan={2}>Cold leaching </TableCell>
                          <TableCell colSpan={2}>
                            Cold leaching Water Level
                          </TableCell>
                          <TableCell colSpan={2}>Hot leaching </TableCell>
                          <TableCell colSpan={2}>
                            Hot leaching Water Level
                          </TableCell>
                          <TableCell colSpan={3}>Hot Leaching</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Start Time</TableCell>
                          <TableCell>End Time </TableCell>
                          <TableCell>Min (Ltr)</TableCell>
                          <TableCell>Max (Ltr)</TableCell>
                          <TableCell>Start Time</TableCell>
                          <TableCell>End Time </TableCell>
                          <TableCell>Min (Ltr)</TableCell>
                          <TableCell>Max (Ltr)</TableCell>
                          <TableCell>Set Temp</TableCell>
                          <TableCell>Min Temp</TableCell>
                          <TableCell>Max Temp</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {leachingData?.map((e) => {
                          return (
                            <>
                              <TableRow>
                                <TableCell>
                                  {e?.cold_leach_cycle_start_time
                                    ? dayjs(
                                        e?.cold_leach_cycle_start_time
                                      ).format("HH:mm:ss")
                                    : "--"}
                                </TableCell>
                                <TableCell>
                                  {e?.cold_leach_cycle_end_time
                                    ? dayjs(
                                        e?.cold_leach_cycle_end_time
                                      ).format("HH:mm:ss")
                                    : "--"}
                                </TableCell>
                                <TableCell>
                                  {e?.cold_leach_min_water_level || "--"}
                                </TableCell>
                                <TableCell>
                                  {e?.cold_leach_max_water_level || "--"}
                                </TableCell>
                                <TableCell>
                                  {e?.hot_leach_cycle_start_time
                                    ? dayjs(
                                        e?.hot_leach_cycle_start_time
                                      ).format("HH:mm:ss")
                                    : "--"}
                                </TableCell>
                                <TableCell>
                                  {e?.hot_leach_cycle_end_time
                                    ? dayjs(e?.hot_leach_cycle_end_time).format(
                                        "HH:mm:ss"
                                      )
                                    : "--"}
                                </TableCell>
                                <TableCell>
                                  {e?.hot_leach_min_water_level || "--"}
                                </TableCell>
                                <TableCell>
                                  {e?.hot_leach_max_water_level || "--"}
                                </TableCell>
                                <TableCell>
                                  {e?.hot_leach_set_temp || "--"}
                                </TableCell>
                                <TableCell>
                                  {e?.hot_leach_min_temp || "--"}
                                </TableCell>
                                <TableCell>
                                  {e?.hot_leach_max_temp || "--"}
                                </TableCell>
                              </TableRow>
                            </>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </div>
                </div>
              </div>
              <div
                className="modal-overlay"
                onClick={() => setWashing2Popup(false)}
              ></div>
            </>
          )}

          {tunnelOvenPopup && (
            <>
              <div
                className="modal-container"
                style={{ height: "40vh", top: "35vh" }}
              >
                <div className="modal-header">
                  <div className="modal-title">TUNNEL OVEN PROCESS SHEET</div>
                  <div
                    onClick={() => setTunnelOvenPopup(false)}
                    style={{ cursor: "pointer" }}
                  >
                    <CloseIcon />
                  </div>
                </div>
                <div className="modal-table-wrapper">
                  <Box sx={{ p: 2 }} style={{ float: "right" }}>
                    {/* Temperature Inputs */}
                    <Grid container spacing={2} alignItems="center">
                      <Grid item>
                        <Typography
                          variant="subtitle1"
                          className="mb-1"
                          style={{ fontWeight: "bold" }}
                        >
                          Zone:
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          style={{ fontWeight: "bold" }}
                        >
                          Set temp (°C):
                        </Typography>
                      </Grid>
                      {temperatures.map((temp, index) => (
                        <Grid item key={index}>
                          <Typography variant="subtitle1" className="mb-1">
                            {index + 1}
                          </Typography>
                          <TextField
                            // type="number"
                            variant="outlined"
                            size="small"
                            value={temp}
                            style={{ pointerEvents: "none" }}
                            // onChange={(e) =>
                            //   handleTemperatureChange(index, e.target.value)
                            // }
                            sx={{ width: 60 }}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                  <div
                    style={{
                      width: "100%",
                      overflow: "auto",
                      maxHeight: "400px",
                    }}
                    className="gloves-report-data"
                  >
                    <Table className="gloves-params">
                      <TableHead>
                        <TableRow>
                          <TableCell rowSpan={2}>IN FEED</TableCell>
                          <TableCell rowSpan={2}>OUT FEED</TableCell>
                          <TableCell colSpan={3}>Hot leaching</TableCell>
                          <TableCell colSpan={2}>Cold leaching</TableCell>
                          <TableCell colSpan={2}>Tunnel oven</TableCell>
                          <TableCell colSpan={9}>
                            TUNNEL OVEN ACTUAL TEMPERATURE ZONE WISE
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Temp (°C)</TableCell>
                          <TableCell>Start</TableCell>
                          <TableCell>End</TableCell>
                          <TableCell>Start</TableCell>
                          <TableCell>End</TableCell>
                          <TableCell>Start</TableCell>
                          <TableCell>End</TableCell>
                          <TableCell>Time</TableCell>
                          <TableCell>Zone 1</TableCell>
                          <TableCell>Zone 2</TableCell>
                          <TableCell>Zone 3</TableCell>
                          <TableCell>Zone 4</TableCell>
                          <TableCell>Zone 5</TableCell>
                          <TableCell>Zone 6</TableCell>
                          <TableCell>Zone 7</TableCell>
                          <TableCell>Zone 8</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {tunnelOvenData.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell>
                              {row.in_feed
                                ? dayjs(row.in_feed).isValid()
                                  ? dayjs(row.in_feed).format("HH:mm:ss")
                                  : "--"
                                : "--"}
                            </TableCell>
                            <TableCell>
                              {row.out_feed
                                ? dayjs(row.out_feed).isValid()
                                  ? dayjs(row.out_feed).format("HH:mm:ss")
                                  : "--"
                                : "--"}
                            </TableCell>
                            <TableCell>
                              {row.leaching_data?.hot_leach_set_temp || "--"}
                            </TableCell>
                            <TableCell>
                              {row.leaching_data?.hot_leach_cycle_start_time &&
                              dayjs(
                                row.leaching_data.hot_leach_cycle_start_time
                              ).isValid()
                                ? dayjs(
                                    row.leaching_data.hot_leach_cycle_start_time
                                  ).format("HH:mm:ss")
                                : "--"}
                            </TableCell>
                            <TableCell>
                              {row.leaching_data?.hot_leach_cycle_end_time &&
                              dayjs(
                                row.leaching_data.hot_leach_cycle_end_time
                              ).isValid()
                                ? dayjs(
                                    row.leaching_data.hot_leach_cycle_end_time
                                  ).format("HH:mm:ss")
                                : "--"}
                            </TableCell>
                            <TableCell>
                              {row.leaching_data?.cold_leach_cycle_start_time &&
                              dayjs(
                                row.leaching_data.cold_leach_cycle_start_time
                              ).isValid()
                                ? dayjs(
                                    row.leaching_data
                                      .cold_leach_cycle_start_time
                                  ).format("HH:mm:ss")
                                : "--"}
                            </TableCell>
                            <TableCell>
                              {row.leaching_data?.cold_leach_cycle_end_time &&
                              dayjs(
                                row.leaching_data.cold_leach_cycle_end_time
                              ).isValid()
                                ? dayjs(
                                    row.leaching_data.cold_leach_cycle_end_time
                                  ).format("HH:mm:ss")
                                : "--"}
                            </TableCell>
                            <TableCell>
                              {row.cycle_start_time &&
                              dayjs(row.cycle_start_time).isValid()
                                ? dayjs(row.cycle_start_time).format("HH:mm:ss")
                                : "--"}
                            </TableCell>
                            <TableCell>
                              {row.cycle_end_time &&
                              dayjs(row.cycle_end_time).isValid()
                                ? dayjs(row.cycle_end_time).format("HH:mm:ss")
                                : "--"}
                            </TableCell>
                            <TableCell>
                              {row.cycle_end_time &&
                              dayjs(row.cycle_end_time).isValid()
                                ? dayjs(row.cycle_end_time).format("HH:mm:ss")
                                : "--"}
                            </TableCell>
                            {[
                              row.actual_temp_zone1,
                              row.actual_temp_zone2,
                              row.actual_temp_zone3,
                              row.actual_temp_zone4,
                              row.actual_temp_zone5,
                              row.actual_temp_zone6,
                              row.actual_temp_zone7,
                              row.actual_temp_zone8,
                            ].map((zone, zoneIndex) => (
                              <TableCell key={zoneIndex}>
                                {zone || "--"}
                              </TableCell>
                            ))}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                </div>
              </div>
              <div
                className="modal-overlay"
                onClick={() => setWashing2Popup(false)}
              ></div>
            </>
          )}

          {autoClavePopup && (
            <>
              <div
                className="modal-container"
                style={{ height: "40vh", top: "35vh" }}
              >
                <div className="modal-header">
                  <div className="modal-title">AUTOCLAVE PROCESS SHEET</div>
                  <div
                    onClick={() => setAutoClavePopup(false)}
                    style={{ cursor: "pointer" }}
                  >
                    <CloseIcon />
                  </div>
                </div>
                <div className="modal-table-wrapper">
                  <div
                    style={{
                      width: "100%",
                      overflow: "auto",
                      maxHeight: "400px",
                    }}
                    className="gloves-report-data"
                  >
                    <Table className="dipping-params">
                      <TableHead>
                        <TableRow>
                          <TableCell>Max Pressure</TableCell>
                          <TableCell>Min Pressure</TableCell>
                          <TableCell>Max Temp(°C)</TableCell>
                          <TableCell>Min Temp(°C)</TableCell>
                          <TableCell>Time (Minutes)</TableCell>
                          <TableCell>Cycle Start Time</TableCell>
                          <TableCell>Cycle End Time</TableCell>
                          <TableCell>Operator</TableCell>
                          <TableCell>Supervisor</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className="gloves-report-body">
                        {autoClaveData?.map((e) => {
                          return (
                            <TableRow>
                              <TableCell>
                                {e.max_pressure ? e.max_pressure : "--"}
                              </TableCell>
                              <TableCell>
                                {e.min_pressure ? e.min_pressure : "--"}
                              </TableCell>
                              <TableCell>
                                {e.max_temp ? e.max_temp : "--"}
                              </TableCell>
                              <TableCell>
                                {e.min_temp ? e.min_temp : "--"}
                              </TableCell>
                              <TableCell>
                                {e.cycle_time_minutes
                                  ? e.cycle_time_minutes
                                  : "--"}
                              </TableCell>

                              <TableCell>
                                {e
                                  ? e?.cycle_start_time
                                    ? dayjs(e.cycle_start_time).format(
                                        "HH:mm:ss"
                                      )
                                    : "--"
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {e
                                  ? e?.cycle_end_time
                                    ? dayjs(e.cycle_end_time).format("HH:mm:ss")
                                    : "--"
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {e.operator ? e.operator : "--"}
                              </TableCell>
                              <TableCell>
                                {e.supervisor ? e.supervisor : "--"}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </div>
                </div>
              </div>
              <div
                className="modal-overlay"
                onClick={() => setAutoClavePopup(false)}
              ></div>
            </>
          )}

          {prong1Popup && (
            <>
              <div
                className="modal-container"
                style={{ height: "40vh", top: "35vh" }}
              >
                <div className="modal-header">
                  <div className="modal-title">PRONG OVEN PROCESS SHEET</div>
                  <div
                    onClick={() => setProng1Popup(false)}
                    style={{ cursor: "pointer" }}
                  >
                    <CloseIcon />
                  </div>
                </div>
                <div className="modal-table-wrapper">
                  <div
                    style={{
                      width: "100%",
                      overflow: "auto",
                      maxHeight: "400px",
                    }}
                    className="gloves-report-data"
                  >
                    <Table className="dipping-params">
                      <TableHead>
                        <TableRow>
                          <TableCell>Batch no.</TableCell>
                          <TableCell>Quantity (Nos)</TableCell>
                          <TableCell>Min Temp(°C)</TableCell>
                          <TableCell>Max Temp(°C)</TableCell>
                          <TableCell>Total Cycle Time (Hr)</TableCell>
                          <TableCell>Cycle Start Date</TableCell>
                          <TableCell>Cycle Start Time</TableCell>
                          <TableCell>Operator</TableCell>
                          <TableCell>Cycle End Date</TableCell>
                          <TableCell>Cycle End Time</TableCell>
                          <TableCell>Supervisor</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className="gloves-report-body">
                        {prongOven1Data?.map((e) => {
                          return (
                            <TableRow>
                              <TableCell>
                                {e.batch_type ? e.batch_type : "--"}
                              </TableCell>
                              <TableCell>
                                {e.quantity ? e.quantity : "--"}
                              </TableCell>
                              <TableCell>
                                {e.min_temp ? e.min_temp : "--"}
                              </TableCell>
                              <TableCell>
                                {e.max_temp ? e.max_temp : "--"}
                              </TableCell>

                              <TableCell>
                                {e.cycle_time_hours ? e.cycle_time_hours : "--"}
                              </TableCell>

                              <TableCell>
                                {e
                                  ? e?.cycle_start_time
                                    ? dayjs(e.cycle_start_time).format(
                                        "YYYY-MM-DD"
                                      )
                                    : "--"
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {e
                                  ? e?.cycle_start_time
                                    ? dayjs(e.cycle_start_time).format(
                                        "HH:mm:ss"
                                      )
                                    : "--"
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {e.operator ? e.operator : "--"}
                              </TableCell>
                              <TableCell>
                                {e
                                  ? e?.cycle_end_time
                                    ? dayjs(e.cycle_end_time).format(
                                        "YYYY-MM-DD"
                                      )
                                    : "--"
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {e
                                  ? e?.cycle_end_time
                                    ? dayjs(e.cycle_end_time).format("HH:mm:ss")
                                    : "--"
                                  : "--"}
                              </TableCell>

                              <TableCell>
                                {e.supervisor ? e.supervisor : "--"}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </div>
                </div>
              </div>
              <div
                className="modal-overlay"
                onClick={() => setProng1Popup(false)}
              ></div>
            </>
          )}

          {prong2Popup && (
            <>
              <div
                className="modal-container"
                style={{ height: "40vh", top: "35vh" }}
              >
                <div className="modal-header">
                  <div className="modal-title">PRONG OVEN PROCESS SHEET</div>
                  <div
                    onClick={() => setProng2Popup(false)}
                    style={{ cursor: "pointer" }}
                  >
                    <CloseIcon />
                  </div>
                </div>
                <div className="modal-table-wrapper">
                  <div
                    style={{
                      width: "100%",
                      overflow: "auto",
                      maxHeight: "400px",
                    }}
                    className="gloves-report-data"
                  >
                    <Table className="dipping-params">
                      <TableHead>
                        <TableRow>
                          <TableCell>Batch no.</TableCell>
                          <TableCell>Quantity (Nos)</TableCell>
                          <TableCell>Min Temp(°C)</TableCell>
                          <TableCell>Max Temp(°C)</TableCell>
                          <TableCell>Total Cycle Time (Hr)</TableCell>
                          <TableCell>Cycle Start Date</TableCell>
                          <TableCell>Cycle Start Time</TableCell>
                          <TableCell>Operator</TableCell>
                          <TableCell>Cycle End Date</TableCell>
                          <TableCell>Cycle End Time</TableCell>
                          <TableCell>Supervisor</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className="gloves-report-body">
                        {prongOven2Data?.map((e) => {
                          return (
                            <TableRow>
                              <TableCell>
                                {e.batch_type ? e.batch_type : "--"}
                              </TableCell>
                              <TableCell>
                                {e.quantity ? e.quantity : "--"}
                              </TableCell>
                              <TableCell>
                                {e.min_temp ? e.min_temp : "--"}
                              </TableCell>
                              <TableCell>
                                {e.max_temp ? e.max_temp : "--"}
                              </TableCell>

                              <TableCell>
                                {e.cycle_time_hours ? e.cycle_time_hours : "--"}
                              </TableCell>

                              <TableCell>
                                {e
                                  ? e?.cycle_start_time
                                    ? dayjs(e.cycle_start_time).format(
                                        "YYYY-MM-DD"
                                      )
                                    : "--"
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {e
                                  ? e?.cycle_start_time
                                    ? dayjs(e.cycle_start_time).format(
                                        "HH:mm:ss"
                                      )
                                    : "--"
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {e.operator ? e.operator : "--"}
                              </TableCell>
                              <TableCell>
                                {e
                                  ? e?.cycle_end_time
                                    ? dayjs(e.cycle_end_time).format(
                                        "YYYY-MM-DD"
                                      )
                                    : "--"
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {e
                                  ? e?.cycle_end_time
                                    ? dayjs(e.cycle_end_time).format("HH:mm:ss")
                                    : "--"
                                  : "--"}
                              </TableCell>

                              <TableCell>
                                {e.supervisor ? e.supervisor : "--"}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </div>
                </div>
              </div>
              <div
                className="modal-overlay"
                onClick={() => setProng2Popup(false)}
              ></div>
            </>
          )}
          {prong3Popup && (
            <>
              <div
                className="modal-container"
                style={{ height: "40vh", top: "35vh" }}
              >
                <div className="modal-header">
                  <div className="modal-title">PRONG OVEN PROCESS SHEET</div>
                  <div
                    onClick={() => setProng3Popup(false)}
                    style={{ cursor: "pointer" }}
                  >
                    <CloseIcon />
                  </div>
                </div>
                <div className="modal-table-wrapper">
                  <div
                    style={{
                      width: "100%",
                      overflow: "auto",
                      maxHeight: "400px",
                    }}
                    className="gloves-report-data"
                  >
                    <Table className="dipping-params">
                      <TableHead>
                        <TableRow>
                          <TableCell>Batch no.</TableCell>
                          <TableCell>Quantity (Nos)</TableCell>
                          <TableCell>Min Temp(°C)</TableCell>
                          <TableCell>Max Temp(°C)</TableCell>
                          <TableCell>Total Cycle Time (Hr)</TableCell>
                          <TableCell>Cycle Start Date</TableCell>
                          <TableCell>Cycle Start Time</TableCell>
                          <TableCell>Operator</TableCell>
                          <TableCell>Cycle End Date</TableCell>
                          <TableCell>Cycle End Time</TableCell>
                          <TableCell>Supervisor</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className="gloves-report-body">
                        {prongOven3Data?.map((e) => {
                          return (
                            <TableRow>
                              <TableCell>
                                {e.batch_type ? e.batch_type : "--"}
                              </TableCell>
                              <TableCell>
                                {e.quantity ? e.quantity : "--"}
                              </TableCell>
                              <TableCell>
                                {e.min_temp ? e.min_temp : "--"}
                              </TableCell>
                              <TableCell>
                                {e.max_temp ? e.max_temp : "--"}
                              </TableCell>

                              <TableCell>
                                {e.cycle_time_hours ? e.cycle_time_hours : "--"}
                              </TableCell>

                              <TableCell>
                                {e
                                  ? e?.cycle_start_time
                                    ? dayjs(e.cycle_start_time).format(
                                        "YYYY-MM-DD"
                                      )
                                    : "--"
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {e
                                  ? e?.cycle_start_time
                                    ? dayjs(e.cycle_start_time).format(
                                        "HH:mm:ss"
                                      )
                                    : "--"
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {e.operator ? e.operator : "--"}
                              </TableCell>
                              <TableCell>
                                {e
                                  ? e?.cycle_end_time
                                    ? dayjs(e.cycle_end_time).format(
                                        "YYYY-MM-DD"
                                      )
                                    : "--"
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {e
                                  ? e?.cycle_end_time
                                    ? dayjs(e.cycle_end_time).format("HH:mm:ss")
                                    : "--"
                                  : "--"}
                              </TableCell>

                              <TableCell>
                                {e.supervisor ? e.supervisor : "--"}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </div>
                </div>
              </div>
              <div
                className="modal-overlay"
                onClick={() => setProng3Popup(false)}
              ></div>
            </>
          )}
          {prong4Popup && (
            <>
              <div
                className="modal-container"
                style={{ height: "40vh", top: "35vh" }}
              >
                <div className="modal-header">
                  <div className="modal-title">PRONG OVEN PROCESS SHEET</div>
                  <div
                    onClick={() => setProng4Popup(false)}
                    style={{ cursor: "pointer" }}
                  >
                    <CloseIcon />
                  </div>
                </div>
                <div className="modal-table-wrapper">
                  <div
                    style={{
                      width: "100%",
                      overflow: "auto",
                      maxHeight: "400px",
                    }}
                    className="gloves-report-data"
                  >
                    <Table className="dipping-params">
                      <TableHead>
                        <TableRow>
                          <TableCell>Batch no.</TableCell>
                          <TableCell>Quantity (Nos)</TableCell>
                          <TableCell>Min Temp(°C)</TableCell>
                          <TableCell>Max Temp(°C)</TableCell>
                          <TableCell>Total Cycle Time (Hr)</TableCell>
                          <TableCell>Cycle Start Date</TableCell>
                          <TableCell>Cycle Start Time</TableCell>
                          <TableCell>Operator</TableCell>
                          <TableCell>Cycle End Date</TableCell>
                          <TableCell>Cycle End Time</TableCell>
                          <TableCell>Supervisor</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className="gloves-report-body">
                        {prongOven4Data?.map((e) => {
                          return (
                            <TableRow>
                              <TableCell>
                                {e.batch_type ? e.batch_type : "--"}
                              </TableCell>
                              <TableCell>
                                {e.quantity ? e.quantity : "--"}
                              </TableCell>
                              <TableCell>
                                {e.min_temp ? e.min_temp : "--"}
                              </TableCell>
                              <TableCell>
                                {e.max_temp ? e.max_temp : "--"}
                              </TableCell>

                              <TableCell>
                                {e.cycle_time_hours ? e.cycle_time_hours : "--"}
                              </TableCell>

                              <TableCell>
                                {e
                                  ? e?.cycle_start_time
                                    ? dayjs(e.cycle_start_time).format(
                                        "YYYY-MM-DD"
                                      )
                                    : "--"
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {e
                                  ? e?.cycle_start_time
                                    ? dayjs(e.cycle_start_time).format(
                                        "HH:mm:ss"
                                      )
                                    : "--"
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {e.operator ? e.operator : "--"}
                              </TableCell>
                              <TableCell>
                                {e
                                  ? e?.cycle_end_time
                                    ? dayjs(e.cycle_end_time).format(
                                        "YYYY-MM-DD"
                                      )
                                    : "--"
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {e
                                  ? e?.cycle_end_time
                                    ? dayjs(e.cycle_end_time).format("HH:mm:ss")
                                    : "--"
                                  : "--"}
                              </TableCell>

                              <TableCell>
                                {e.supervisor ? e.supervisor : "--"}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </div>
                </div>
              </div>
              <div
                className="modal-overlay"
                onClick={() => setProng4Popup(false)}
              ></div>
            </>
          )}
          {acConditioningPopup && (
            <>
              <div
                className="modal-container"
                style={{ height: "40vh", top: "35vh" }}
              >
                <div className="modal-header">
                  <div className="modal-title">
                    AC CONDITIONING PROCESS SHEET
                  </div>
                  <div
                    onClick={() => setAcConditioningPopup(false)}
                    style={{ cursor: "pointer" }}
                  >
                    <CloseIcon />
                  </div>
                </div>
                <div className="modal-table-wrapper">
                  <div
                    style={{
                      width: "100%",
                      overflow: "auto",
                      maxHeight: "400px",
                    }}
                    className="gloves-report-data"
                  >
                    <Table className="dipping-params">
                      <TableHead>
                        <TableRow>
                          <TableCell>Class</TableCell>
                          <TableCell>Size</TableCell>
                          <TableCell>RE.SC</TableCell>
                          <TableCell>Bin. No</TableCell>
                          <TableCell>QTY</TableCell>
                          <TableCell>Start Date</TableCell>
                          <TableCell>Start Time</TableCell>
                          <TableCell>End Date</TableCell>
                          <TableCell>End Time</TableCell>
                          <TableCell>Require Time</TableCell>
                          <TableCell>Actual Time</TableCell>
                          <TableCell>Operator Name</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className="gloves-report-body">
                        {acConditioningData?.map((e) => {
                          return (
                            <TableRow>
                              <TableCell>
                                {e.class_name ? e.class_name : "--"}
                              </TableCell>
                              <TableCell>
                                {e.size_name ? e.size_name : "--"}
                              </TableCell>
                              <TableCell>{e.sc_re ? e.sc_re : "--"}</TableCell>
                              <TableCell>
                                {e.bin_number ? e.bin_number : "--"}
                              </TableCell>
                              <TableCell>
                                {e.quantity ? e.quantity : "--"}
                              </TableCell>
                              <TableCell>
                                {e
                                  ? e?.cycle_start_time
                                    ? dayjs(e.cycle_start_time).format(
                                        "YYYY-MM-DD"
                                      )
                                    : "--"
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {e
                                  ? e?.cycle_start_time
                                    ? dayjs(e.cycle_start_time).format(
                                        "HH:mm:ss"
                                      )
                                    : "--"
                                  : "--"}
                              </TableCell>

                              <TableCell>
                                {e
                                  ? e?.cycle_end_time
                                    ? dayjs(e.cycle_end_time).format(
                                        "YYYY-MM-DD"
                                      )
                                    : "--"
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {e
                                  ? e?.cycle_end_time
                                    ? dayjs(e.cycle_end_time).format("HH:mm:ss")
                                    : "--"
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {e.require_time ? e.require_time : "--"}
                              </TableCell>
                              <TableCell>
                                {e.actual_time ? e.actual_time : "--"}
                              </TableCell>
                              <TableCell>
                                {e.operator ? e.operator : "--"}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </div>
                </div>
              </div>
              <div
                className="modal-overlay"
                onClick={() => setAcConditioningPopup(false)}
              ></div>
            </>
          )}
          {extraConditioningPopup && (
            <>
              <div
                className="modal-container"
                style={{ height: "40vh", top: "35vh" }}
              >
                <div className="modal-header">
                  <div className="modal-title">
                    EXTRA AC CONDITIONING PROCESS SHEET
                  </div>
                  <div
                    onClick={() => setExtraConditioningPopup(false)}
                    style={{ cursor: "pointer" }}
                  >
                    <CloseIcon />
                  </div>
                </div>
                <div className="modal-table-wrapper">
                  <div
                    style={{
                      width: "100%",
                      overflow: "auto",
                      maxHeight: "400px",
                    }}
                    className="gloves-report-data"
                  >
                    <Table className="dipping-params">
                      <TableHead>
                        <TableRow>
                          <TableCell>Class</TableCell>
                          <TableCell>Size</TableCell>
                          <TableCell>RE.SC</TableCell>
                          <TableCell>Bin. No</TableCell>
                          <TableCell>QTY</TableCell>
                          <TableCell>Start Date</TableCell>
                          <TableCell>Start Time</TableCell>
                          <TableCell>End Date</TableCell>
                          <TableCell>End Time</TableCell>
                          <TableCell>Require Time</TableCell>
                          <TableCell>Actual Time</TableCell>
                          <TableCell>Operator Name</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className="gloves-report-body">
                        {extraConditioningData?.map((e) => {
                          return (
                            <TableRow>
                              <TableCell>
                                {e.class_name ? e.class_name : "--"}
                              </TableCell>
                              <TableCell>
                                {e.size_name ? e.size_name : "--"}
                              </TableCell>
                              <TableCell>{e.sc_re ? e.sc_re : "--"}</TableCell>
                              <TableCell>
                                {e.bin_number ? e.bin_number : "--"}
                              </TableCell>
                              <TableCell>
                                {e.quantity ? e.quantity : "--"}
                              </TableCell>
                              <TableCell>
                                {e
                                  ? e?.cycle_start_time
                                    ? dayjs(e.cycle_start_time).format(
                                        "YYYY-MM-DD"
                                      )
                                    : "--"
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {e
                                  ? e?.cycle_start_time
                                    ? dayjs(e.cycle_start_time).format(
                                        "HH:mm:ss"
                                      )
                                    : "--"
                                  : "--"}
                              </TableCell>

                              <TableCell>
                                {e
                                  ? e?.cycle_end_time
                                    ? dayjs(e.cycle_end_time).format(
                                        "YYYY-MM-DD"
                                      )
                                    : "--"
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {e
                                  ? e?.cycle_end_time
                                    ? dayjs(e.cycle_end_time).format("HH:mm:ss")
                                    : "--"
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {e.require_time ? e.require_time : "--"}
                              </TableCell>
                              <TableCell>
                                {e.actual_time ? e.actual_time : "--"}
                              </TableCell>
                              <TableCell>
                                {e.operator ? e.operator : "--"}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </div>
                </div>
              </div>
              <div
                className="modal-overlay"
                onClick={() => setExtraConditioningPopup(false)}
              ></div>
            </>
          )}
          {cuttingPopup && (
            <>
              <div
                className="modal-container"
                style={{ height: "40vh", top: "35vh" }}
              >
                <div className="modal-header">
                  <div className="modal-title">
                    CUTTING MACHINE PROCESS SHEET
                  </div>
                  <div
                    onClick={() => setCuttingPopup(false)}
                    style={{ cursor: "pointer" }}
                  >
                    <CloseIcon />
                  </div>
                </div>
                <div className="modal-table-wrapper">
                  <div
                    style={{
                      width: "100%",
                      overflow: "auto",
                      maxHeight: "400px",
                    }}
                    className="gloves-report-data"
                  >
                    <Table className="dipping-params">
                      <TableHead>
                        <TableRow>
                          <TableCell>Class</TableCell>
                          <TableCell>Size</TableCell>
                          <TableCell>Actual Length</TableCell>
                          <TableCell>Set Length</TableCell>
                          <TableCell>Quantity (Nos)</TableCell>
                          <TableCell>Operator Name</TableCell>
                          <TableCell>QA Signature</TableCell>
                          <TableCell>Production Signature</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className="gloves-report-body">
                        {cuttingData?.map((e) => {
                          return (
                            <TableRow>
                              <TableCell>
                                {e.class_name ? e.class_name : "--"}
                              </TableCell>
                              <TableCell>
                                {e.size_name ? e.size_name : "--"}
                              </TableCell>
                              <TableCell>
                                {e.actual_length ? e.actual_length : "--"}
                              </TableCell>
                              <TableCell>
                                {e.set_length ? e.set_length : "--"}
                              </TableCell>
                              <TableCell>
                                {e.quantity ? e.quantity : "--"}
                              </TableCell>

                              <TableCell>
                                {e.operator ? e.operator : "--"}
                              </TableCell>
                              <TableCell>--</TableCell>
                              <TableCell>--</TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </div>
                </div>
              </div>
              <div
                className="modal-overlay"
                onClick={() => setExtraConditioningPopup(false)}
              ></div>
            </>
          )}
          {chlorinationPopup && (
            <>
              <div
                className="modal-container"
                style={{ height: "40vh", top: "35vh" }}
              >
                <div className="modal-header">
                  <div className="modal-title">CHLORINATION PROCESS SHEET</div>
                  <div
                    onClick={() => setchlorinationPopup(false)}
                    style={{ cursor: "pointer" }}
                  >
                    <CloseIcon />
                  </div>
                </div>
                <div className="modal-table-wrapper">
                  <div
                    style={{
                      width: "100%",
                      overflow: "auto",
                      maxHeight: "400px",
                    }}
                    className="gloves-report-data"
                  >
                    <Table className="dipping-params">
                      <TableHead>
                        <TableRow>
                          <TableCell>Batch No.</TableCell>
                          <TableCell>Receipe</TableCell>
                          <TableCell>Start Time</TableCell>
                          <TableCell>End Time</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className="gloves-report-body">
                        {chlorinationData?.map((e) => {
                          return (
                            <TableRow>
                              <TableCell>
                                {e.batch_type ? e.batch_type : "--"}
                              </TableCell>
                              <TableCell>
                                {e.recipe ? e.recipe : "--"}
                              </TableCell>
                              <TableCell>
                                {e
                                  ? e?.cycle_start_time
                                    ? dayjs(e.cycle_start_time).format(
                                        "HH:mm:ss"
                                      )
                                    : "--"
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {e
                                  ? e?.cycle_end_time
                                    ? dayjs(e.cycle_end_time).format("HH:mm:ss")
                                    : "--"
                                  : "--"}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </div>
                </div>
              </div>
              <div
                className="modal-overlay"
                onClick={() => setchlorinationPopup(false)}
              ></div>
            </>
          )}
          {dippingpopup && (
            <RobotParameter
              dippingPopup={dippingpopup}
              setDippingPopup={setDippingPopup}
            />
          )}

          {strippingPopup && (
            <>
              <div
                className="modal-container"
                style={{ height: "40vh", top: "35vh" }}
              >
                <div className="modal-header">
                  <div className="modal-title">STRIPPING PROCESS SHEET</div>
                  <div
                    onClick={() => setStrippingPopup(false)}
                    style={{ cursor: "pointer" }}
                  >
                    <CloseIcon />
                  </div>
                </div>
                <div className="modal-table-wrapper">
                  <div
                    style={{
                      width: "100%",
                      overflow: "auto",
                      maxHeight: "400px",
                    }}
                    className="gloves-report-data"
                  >
                    <Table className="dipping-params">
                      <TableHead>
                        <TableRow>
                          <TableCell>Batch no.</TableCell>
                          <TableCell>Class</TableCell>
                          <TableCell>Size</TableCell>
                          <TableCell>Cycle Start Time</TableCell>
                          <TableCell>Cycle End Time</TableCell>
                          <TableCell>Operator</TableCell>
                          <TableCell>Supervisor</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className="gloves-report-body">
                        {strippingData?.map((e) => {
                          return (
                            <TableRow>
                              <TableCell>
                                {e.batch_type ? e.batch_type : "--"}
                              </TableCell>
                              <TableCell>
                                {e.class_name ? e.class_name : "--"}
                              </TableCell>
                              <TableCell>
                                {e.size_name ? e.size_name : "--"}
                              </TableCell>

                              <TableCell>
                                {e
                                  ? e?.cycle_start_time
                                    ? dayjs(e.cycle_start_time).format(
                                        "HH:mm:ss"
                                      )
                                    : "--"
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {e
                                  ? e?.cycle_end_time
                                    ? dayjs(e.cycle_end_time).format("HH:mm:ss")
                                    : "--"
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {e.operator ? e.operator : "--"}
                              </TableCell>
                              <TableCell>
                                {e.supervisor ? e.supervisor : "--"}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </div>
                </div>
              </div>
              <div
                className="modal-overlay"
                onClick={() => setStrippingPopup(false)}
              ></div>
            </>
          )}

          {staticLeachingPopup && (
            <>
              <div
                className="modal-container"
                style={{ height: "40vh", top: "35vh" }}
              >
                <div className="modal-header">
                  <div className="modal-title">
                    STATIC LEACHING PROCESS SHEET
                  </div>
                  <div
                    onClick={() => setStatingLeachingPopup(false)}
                    style={{ cursor: "pointer" }}
                  >
                    <CloseIcon />
                  </div>
                </div>
                <div className="modal-table-wrapper">
                  <div
                    style={{
                      width: "100%",
                      overflow: "auto",
                      maxHeight: "400px",
                    }}
                    className="gloves-report-data"
                  >
                    <Table className="dipping-params">
                      <TableHead>
                        <TableRow>
                          <TableCell>Batch no.</TableCell>
                          <TableCell>Conductivity</TableCell>
                          <TableCell>Cycle Start Time</TableCell>
                          <TableCell>Cycle End Time</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className="gloves-report-body">
                        {staticLeachingData?.map((e) => {
                          console.log("shdjkasdjksj", e);
                          return (
                            <TableRow>
                              <TableCell>
                                {e.batch_type ? e.batch_type : "--"}
                              </TableCell>

                              <TableCell>
                                {e.conductivity ? e.conductivity : "--"}
                              </TableCell>

                              <TableCell>
                                {e
                                  ? e?.cycle_start_time
                                    ? dayjs(e.cycle_start_time).format(
                                        "HH:mm:ss"
                                      )
                                    : "--"
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {e
                                  ? e?.cycle_end_time
                                    ? dayjs(e.cycle_end_time).format("HH:mm:ss")
                                    : "--"
                                  : "--"}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </div>
                </div>
              </div>
              <div
                className="modal-overlay"
                onClick={() => setStatingLeachingPopup(false)}
              ></div>
            </>
          )}

          {tumbleDryingPopup && (
            <>
              <div
                className="modal-container"
                style={{ height: "40vh", top: "35vh" }}
              >
                <div className="modal-header">
                  <div className="modal-title">
                    TUMBLE DRYING 1 PROCESS SHEET
                  </div>
                  <div
                    onClick={() => setTumbleDryingPopup(false)}
                    style={{ cursor: "pointer" }}
                  >
                    <CloseIcon />
                  </div>
                </div>
                <div className="modal-table-wrapper">
                  <div
                    style={{
                      width: "100%",
                      overflow: "auto",
                      maxHeight: "400px",
                    }}
                    className="gloves-report-data"
                  >
                    <Table className="dipping-params">
                      <TableHead>
                        <TableRow>
                          <TableCell>Max temp</TableCell>
                          <TableCell>Min temp</TableCell>

                          <TableCell>Time Minutes</TableCell>

                          <TableCell>Cycle Start Time</TableCell>
                          <TableCell>Cycle End Time</TableCell>
                          <TableCell>Operator</TableCell>
                          <TableCell>Supervisor</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className="gloves-report-body">
                        {tumbleDryingData?.map((e) => {
                          console.log("shdjkasdjksj", e);
                          return (
                            <TableRow>
                              <TableCell>
                                {e.max_temp ? e.max_temp : "--"}
                              </TableCell>
                              <TableCell>
                                {e.min_temp ? e.min_temp : "--"}
                              </TableCell>
                              <TableCell>
                                {e.time_minutes ? e.time_minutes : "--"}
                              </TableCell>

                              <TableCell>
                                {e
                                  ? e?.cycle_start_time
                                    ? dayjs(e.cycle_start_time).format(
                                        "HH:mm:ss"
                                      )
                                    : "--"
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {e
                                  ? e?.cycle_end_time
                                    ? dayjs(e.cycle_end_time).format("HH:mm:ss")
                                    : "--"
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {e.operator ? e.operator : "--"}
                              </TableCell>
                              <TableCell>
                                {e.supervisor ? e.supervisor : "--"}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </div>
                </div>
              </div>
              <div
                className="modal-overlay"
                onClick={() => setTumbleDryingPopup(false)}
              ></div>
            </>
          )}
          {tumbleDrying2Popup && (
            <>
              <div
                className="modal-container"
                style={{ height: "40vh", top: "35vh" }}
              >
                <div className="modal-header">
                  <div className="modal-title">
                    TUMBLE DRYING 2 PROCESS SHEET
                  </div>
                  <div
                    onClick={() => setTumbleDrying2Popup(false)}
                    style={{ cursor: "pointer" }}
                  >
                    <CloseIcon />
                  </div>
                </div>
                <div className="modal-table-wrapper">
                  <div
                    style={{
                      width: "100%",
                      overflow: "auto",
                      maxHeight: "400px",
                    }}
                    className="gloves-report-data"
                  >
                    <Table className="dipping-params">
                      <TableHead>
                        <TableRow>
                          <TableCell>Max temp</TableCell>
                          <TableCell>Min temp</TableCell>

                          <TableCell>Time Minutes</TableCell>

                          <TableCell>Cycle Start Time</TableCell>
                          <TableCell>Cycle End Time</TableCell>
                          <TableCell>Operator</TableCell>
                          <TableCell>Supervisor</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className="gloves-report-body">
                        {tumbleDrying2Data?.map((e) => {
                          console.log("shdjkasdjksj", e);
                          return (
                            <TableRow>
                              <TableCell>
                                {e.max_temp ? e.max_temp : "--"}
                              </TableCell>
                              <TableCell>
                                {e.min_temp ? e.min_temp : "--"}
                              </TableCell>
                              <TableCell>
                                {e.time_minutes ? e.time_minutes : "--"}
                              </TableCell>

                              <TableCell>
                                {e
                                  ? e?.cycle_start_time
                                    ? dayjs(e.cycle_start_time).format(
                                        "HH:mm:ss"
                                      )
                                    : "--"
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {e
                                  ? e?.cycle_end_time
                                    ? dayjs(e.cycle_end_time).format("HH:mm:ss")
                                    : "--"
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {e.operator ? e.operator : "--"}
                              </TableCell>
                              <TableCell>
                                {e.supervisor ? e.supervisor : "--"}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </div>
                </div>
              </div>
              <div
                className="modal-overlay"
                onClick={() => setTumbleDrying2Popup(false)}
              ></div>
            </>
          )}
          {isPopup ? (
            <>
              <div className="sendingdataaaa1">
                <Card className="pairingcard-Approved">
                  <CardContent className="p-0 pairing-status">
                    <h4>Are you sure you want to get the excel ?</h4>
                  </CardContent>
                  <Button
                    className="pairingcard-btn"
                    style={{ margin: "20px 6px" }}
                    title="Yes"
                    onClick={() => handleExcelClick()}
                  />
                  <Button
                    className="pairingcard-btn"
                    title="No"
                    onClick={() => setisPopup(false)}
                  />
                </Card>
              </div>
            </>
          ) : null}
          {successPopup && (
            <>
              <div className="sendingData">
                <Card className="card-printer">
                  <CardContent>
                    <h4 className="card-content">
                      <b>
                        Email Sent to Your Mailbox!{" "}
                        <img
                          src={require("../../assets/images/correctIcon.png")}
                          style={{ height: "25px", width: "25px" }}
                          alt=""
                        />
                      </b>
                    </h4>
                  </CardContent>
                </Card>
              </div>
              <div className="sending-uid-overlay" on></div>
            </>
          )}
        </div>
      )}
    </>
  );
};
export default GlovesReport;
